module.exports = __webpack_public_path__ + "static/media/vajro_bg_image.873ddbbc.jpg";